import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApplicationsFiltersState {
  tabsAdmissionsOffice: string;
}

const initialState: ApplicationsFiltersState = {
  tabsAdmissionsOffice: "",
};

const admissionOfficeDocSlice = createSlice({
  name: "headerTabs",
  initialState,
  reducers: {
    setTabsAdmissionsOffice(state, action: PayloadAction<string>) {
      state.tabsAdmissionsOffice = action.payload;
    },
  },
});

export const { setTabsAdmissionsOffice } = admissionOfficeDocSlice.actions;
export default admissionOfficeDocSlice.reducer;
